import { Breadcrumbs, Link, Typography } from '@mui/material'
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom'
import { Home, NavigateNextOutlined } from '@mui/icons-material'

const getRoutePath = (location, params) => {
  let path = location
  Object.entries(params).forEach(([paramName, paramValue]) => {
    if (paramValue) {
      path = path.replace(paramValue, `:${paramName}`)
    }
  })
  return path
}

const breadcrumbNameMap = {
  '/area-cliente': 'Início',
  '/area-cliente/faturas': 'Faturas',
  '/area-cliente/faturas/:id': 'Detalhes da Fatura',
  '/area-cliente/cobrancas': 'Cobranças',
  '/area-cliente/cobrancas/:id': 'Detalhes da Cobrança',
}

const TenantBreadCrumbs = () => {
  const location = useLocation()
  const params = useParams()
  const pathNames = location.pathname.split('/').filter((x) => x)
  const LinkRouter = (props) => <Link {...props} component={RouterLink}/>

  return (
    <Breadcrumbs
      sx={{ display: { xs: 'none', md: 'block' } }}
      aria-label="breadcrumb"
      separator={<NavigateNextOutlined fontSize={'small'}/>}
    >
      <LinkRouter underline="hover" color="inherit" to="/area-cliente/" sx={{ display: 'flex', alignItems: 'center' }}>
        <Home color={'primary'}/>
      </LinkRouter>
      {pathNames.map((value, index) => {
        const last = index === pathNames.length - 1
        const to = `/${pathNames.slice(0, index + 1).join('/')}`
        const route = getRoutePath(to, params)

        if (breadcrumbNameMap[route] !== undefined) {
          return last ? (
            <Typography color="text.primary" key={to}>
              {breadcrumbNameMap[route]}
            </Typography>
          ) : (
            <LinkRouter underline="hover" color="inherit" to={to} key={to}>
              {breadcrumbNameMap[route]}
            </LinkRouter>
          )
        }
        return null
      })}
    </Breadcrumbs>
  )
}

export default TenantBreadCrumbs
